// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3M4xy","head":"ProcedureTableInfo_head__245FE"};